"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TitleIcon = ({
  icon
}) => {
  if (icon === undefined) {
    return null;
  }
  const ResultIcon = _styles.titleIcons[icon];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ResultIcon, {
    fontSize: "inherit"
  });
};
exports.TitleIcon = TitleIcon;
